import { useEffect, RefObject } from 'react';

interface UseScrollToTopOnOpenOptions {
  trigger: boolean;
  scrollRef: RefObject<HTMLElement | null>;
  modalSelector?: string | Element | null;
  fallbackDelay?: number;
}

export const useScrollToTopOnOpen = ({
  trigger,
  scrollRef,
  modalSelector,
  fallbackDelay = 150,
}: UseScrollToTopOnOpenOptions) => {
  useEffect(() => {
    if (!trigger || !scrollRef.current) return;

    // 🔒 Сохраняем текущий элемент в переменную — он не изменится в замыкании
    const el = scrollRef.current;
    const originalBehavior = el.style.scrollBehavior;

    el.style.scrollBehavior = 'auto';

    const finishScroll = () => {
      requestAnimationFrame(() => {
        void el.offsetTop;
        el.scrollTop = 0;

        setTimeout(() => {
          el.style.scrollBehavior = originalBehavior;
        }, 0);
      });
    };

    const modal =
      typeof modalSelector === 'string'
        ? document.querySelector(modalSelector)
        : modalSelector || null;

    if (modal) {
      const handleTransitionEnd = (e: Event) => {
        if (e.target === modal) {
          finishScroll();
          modal.removeEventListener('transitionend', handleTransitionEnd);
        }
      };

      modal.addEventListener('transitionend', handleTransitionEnd);
      const fallback = setTimeout(finishScroll, fallbackDelay);

      // ✅ В cleanup используем сохранённую переменную `el`, а не `scrollRef.current`
      return () => {
        clearTimeout(fallback);
        modal.removeEventListener('transitionend', handleTransitionEnd);
        el.style.scrollBehavior = originalBehavior; // 👈 здесь была проблема
      };
    } else {
      finishScroll();
      return () => {
        el.style.scrollBehavior = originalBehavior;
      };
    }
  }, [trigger, scrollRef, modalSelector, fallbackDelay]);
};